/**
 * Central navigation definition.
 *
 * The single list from which the sidebar, router and command palette are all
 * built — add a destination here and it appears everywhere consistently.
 */
import {
  MessageSquare,
  FolderClosed,
  Library,
  Brain,
  Boxes,
  Settings,
  Info,
  FileText,
  Sparkles,
  FolderKanban,
  SquareCheck,
  Search,
  Clipboard,
} from "lucide-react";
import type { NavItem } from "@/types";

export const PRIMARY_NAV: readonly NavItem[] = [
  { id: "chat", label: "Chat", path: "/chat", icon: MessageSquare, shortcut: "1" },
  { id: "notes", label: "Notes", path: "/notes", icon: FileText, shortcut: "2" },
  { id: "prompts", label: "Prompts", path: "/prompts", icon: Sparkles, shortcut: "3" },
  { id: "projects", label: "Projects", path: "/projects", icon: FolderKanban, shortcut: "4" },
  { id: "tasks", label: "Tasks", path: "/tasks", icon: SquareCheck, shortcut: "5" },
  { id: "files", label: "Files", path: "/files", icon: FolderClosed, shortcut: "6" },
  { id: "knowledge", label: "Knowledge", path: "/knowledge", icon: Library, shortcut: "7" },
  { id: "memory", label: "Memory", path: "/memory", icon: Brain, shortcut: "8" },
  { id: "models", label: "Models", path: "/models", icon: Boxes, shortcut: "9" },
] as const;

export const SECONDARY_NAV: readonly NavItem[] = [
  { id: "search", label: "Search", path: "/search", icon: Search },
  { id: "clipboard", label: "Clipboard", path: "/clipboard", icon: Clipboard },
  { id: "settings", label: "Settings", path: "/settings", icon: Settings, shortcut: "," },
  { id: "about", label: "About", path: "/about", icon: Info },
] as const;

export const ALL_NAV: readonly NavItem[] = [...PRIMARY_NAV, ...SECONDARY_NAV];
